
import XHeader from 'vux/src/components/x-header/index.vue'
import Badge from 'vux/src/components/badge/index.vue'

import vuescroll from 'vuescroll'
import Error from '@/components/error'
export default {
name: 'notice',
components: {
XHeader,
Badge,
Error,
'scroller': vuescroll
},
data () {
return {
title: this.$route.meta.title,
allState: false,
errorMsg: {
type: 'null',
content: '暂无私信'
},
isFirstLoad: true,
isNoMoreData: false,
current: 1,
totalPage: 0,
list: [],
listNew: [],
scrollHeight: 0,
ops: {
vuescroll: {
mode: 'slide',
pullRefresh: {
enable: true,
tips: {
deactive: '下拉刷新',
active: '释放刷新',
start: '刷新中...',
beforeDeactive: '刷新成功!'
}
},
pushLoad: {
enable: true,
tips: {
deactive: '上拉加载',
active: '释放加载',
start: '加载中...',
beforeDeactive: '加载成功!'
}
}
},
bar: {
background: 'rgba(0, 107, 178, 0.3)',
size: '3px',
opacity: 0
}
}
}
},
computed: {
},
created () {
},
mounted () {
this.$vux.loading.show({
text: '加载中'
})
this.getList()
this.getScrollHeight()
this.getMessageUnread()
},
updated () {},
destroyed () {},
watch: {},
methods: {
back () {
setTimeout(() => {
this.$router.back(-1)
}, 300)
},
getScrollHeight () {
this.scrollHeight = document.documentElement.clientHeight - 47
},

readAll () {
this.list.forEach(function (c) {
c.flag = '1000000000'
})
this.allState = true
},

getList () {
let pageSize = 10
let params = {}
this.listNew = []
params.sendType = 0
params.status = 0
params.pageSize = pageSize
params.current = this.current
this.$api.get('/message/info/page', params, r => {
this.$vux.loading.hide()
this.totalPage = Math.ceil(r.data.totalCount / pageSize)
if (r.data.list.length > 0) {
this.listNew = r.data.list
}
if (this.isFirstLoad) {
this.list = r.data.list
if (this.$refs['vs'] && r.data.list.length > 0) {
this.$refs['vs'].refresh()
}
}
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},

getMessageUnread () {
let params = {}
params.status = 0
params.isRead = 0
params.sendType = 0
this.$api.get('/message/info', params, r => {
this.$vux.loading.hide()
if (r.data.length > 0) {
this.allState = false
} else {
this.allState = true
}
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},
handleRS (vsInstance, refreshDom, done) {
setTimeout(() => {
this.isFirstLoad = false
this.isNoMoreData = false
this.current = 1
this.getList()
done()
}, 1500)
},
handleLoadStart (vm, dom, done) {
setTimeout(() => {
this.isFirstLoad = false
if (this.current < this.totalPage) {
this.current += 1
this.getList()
this.ops.vuescroll.pushLoad.tips.beforeDeactive = '加载成功'
} else {
this.isNoMoreData = true
this.ops.vuescroll.pushLoad.tips.beforeDeactive = '没有更多数据了'
}
done()
}, 600)
},
handleLBD (vm, loadDom, done) {
setTimeout(() => {
if (!this.isNoMoreData) {
this.list = this.list.concat(this.listNew)
}
this.$refs['vs'].refresh()
done()
}, 500)
},
handleRBD (vm, loadDom, done) {
setTimeout(() => {
this.list = []
this.list = this.list.concat(this.listNew)
this.$refs['vs'].refresh()
done()
}, 500)
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/notice/messageList.vue